/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { LOGIN_ROUTE } from './routes';

function ProtectedRoute({ path, component: Component }) {
  const isLogged = useSelector((state) => state.auth.jwtToken !== null);

  return (
    <Route path={path}>
      {(props) => {
        return isLogged ? <Component {...props} /> : <Redirect to={LOGIN_ROUTE} />
      }}
    </Route>
  );
}

ProtectedRoute.propTypes = {
  path: PropTypes.string.isRequired,
  component: PropTypes.elementType.isRequired
}

export default ProtectedRoute;
